<template>
  <div>
    <div style="overflow: hidden">
      <slot name="title"> </slot>
      <div style="display: flex; float: left; gap: 15px;margin-top: 10px;">
        <span>总上架数：{{totalUpNum}}</span>
        <span>总下架数：{{totalDownNum}}</span>
        <span>总租车数：{{totalRentNum}}</span>
        <span>总还车数：{{totalReturnNum}}</span>
      </div>
      <span class="btn-group">
        <el-select
          v-if="dataType === '年'"
          style="width: 100px;margin-right: 16px"
          @change="tidal"
          size="mini"
          v-model="selectYear"
          placeholder="请选择">
          <el-option
            v-for="item in selectYears"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-button class="btn-hover" size="mini" @click="onExportLogShowModel">导出</el-button>
        <el-radio-group
          @change="onDataType"
          size="mini"
          v-model="dataType"
          style="margin-left: 16px">
          <el-radio-button label="日"></el-radio-button>
          <el-radio-button label="月"></el-radio-button>
          <el-radio-button label="年"></el-radio-button>
        </el-radio-group>
      </span>
    </div>
    <div id="chart1" :style="{ height: height + 'px' }"></div>
    <!-- 一级弹窗 -->
    <w-dialog
      ref="monthchart"
      :title="dialogTitleMonth"
      width="55%"
      :className="dark ? 'i-dialog' : ''"
      :isShowFooter="false"
      @handleCloseRight="handleCloseMonth">
      <template v-slot:content>
        <div id="chart2"></div>
      </template>
    </w-dialog>
    <w-dialog
      ref="daychart"
      :title="dialogTitleDay"
      width="55%"
      :className="dark ? 'i-dialog' : ''"
      :isShowFooter="false"
      @handleCloseRight="handleCloseDay">
      <template v-slot:content>
        <div id="chart3"></div>
      </template>
    </w-dialog>
    <w-dialog
      width="35%"
      ref="export-log"
      title="导出设置"
      :className="dark ? 'i-dialog' : ''"
      sureBtnText="导出"
      @handleCloseRight="handleCloseExportLog"
      @handleClose="handleCloseExportLog"
      @onSure="onExportLog">
      <template v-slot:content>
        <el-form ref="form" :model="form" label-width="100px">
          <el-form-item label="时间类型：">
            <el-radio-group size="mini" v-model="form.dataType">
              <el-radio-button label="日"></el-radio-button>
              <el-radio-button label="月"></el-radio-button>
              <el-radio-button label="年"></el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="选择时间：">
            <el-date-picker
              v-if="form.dataType === '日'"
              style="width: 130px"
              size="mini"
              v-model="form.exportTime"
              type="date"
              :clearable="false"
              placeholder="选择日期">
            </el-date-picker>
            <el-date-picker
              v-else-if="form.dataType === '月'"
              style="width: 130px"
              size="mini"
              v-model="form.exportTime"
              type="month"
              :clearable="false"
              placeholder="选择月"
              format="yyyy-MM"/>
            <el-date-picker
              v-else
              size="mini"
              style="width: 130px"
              v-model="form.exportTime"
              type="year"
              :clearable="false"
              placeholder="选择年"
              format="yyyy"/>
            </el-form-item>
          <el-form-item label="具体时间">
            <el-checkbox
              :indeterminate="isIndeterminate"
              v-model="checkAll"
              @change="handleCheckAllChange"
              >全选</el-checkbox>
            <el-checkbox-group size="mini" v-model="form.group" @change="handleCheckedChange">
               <el-checkbox v-for="item in group" :label="item.key" :key="item.key" >{{item.name}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </template>
    </w-dialog>
  </div>
</template>

<script>
import Api from '@/api'
import { Line } from '@antv/g2plot'
import WDialog from '@/components/Model/index.vue'

export default {
  components: {
    WDialog
  },
  data() {
    return {
      isIndeterminate: false,
      checkAll: true,
      form: {
        dataType: '日',
        exportTime: new Date(),
        group: []
      },
      height: 300,
      monthCache: null,
      chart: null, // 潮汐
      chartDays: null,
      chartMonths: null,
      dataType: '月', // 0-日，1-月，2-年
      selectYear: undefined,
      selectYears: [],
      dialogTitleDay: '',
      dialogTitleMonth: '',
      totalRentNum: 0, // 总租车数
      totalReturnNum: 0, // 总还车数
      totalUpNum: 0, // 总上架数
      totalDownNum: 0 // 总下架数
    }
  },
  props: {
    realHeight: {
      type: Number,
      default: 300
    },
    selfAreaId: {
      type: String,
      default: ''
    },
    isAggregation: {
      type: [Boolean, String],
      default: false
    },
    siteId: {
      type: String,
      default: ''
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    group() {
      const dataType = this.form.dataType
      const arr = []
      const newArr = []
      if (dataType === '日') {
        for (var i = 0; i <= 23; i++) {
          arr.push({ key: i, name: i + '时' })
          newArr.push(i)
        }
      } else if (dataType === '月') {
        const max = Number(
          this.dayjs(this.form.exportTime).endOf('month').format('DD')
        )
        for (var j = 1; j <= max; j++) {
          arr.push({ key: j, name: j + '日' })
          newArr.push(j)
        }
      } else if (dataType === '年') {
        const max = Number(
          this.dayjs(this.form.exportTime).endOf('year').format('MM')
        )
        for (var k = 1; k <= max; k++) {
          arr.push({ key: k, name: k + '月' })
          newArr.push(k)
        }
      }
      this.isIndeterminate = false
      this.checkAll = true
      this.$set(this.form, 'group', newArr)
      return arr
    }
  },
  watch: {
    siteId(val) {
      if (val) {
        this.tidal()
      }
    }
  },
  created() {
    this.yearChange()
    this.tidal()
  },
  methods: {
    yearChange () {
      var newDate = new Date()
      var startYear = newDate.getFullYear() - 4// 起始年份
      var endYear = newDate.getFullYear()// 结束年份
      this.selectYears = []
      for (var i = startYear; i <= endYear; i++) {
        this.selectYears.push({
          value: (i + ''),
          label: (i + '年')
        })
      }
      this.selectYears.sort((a, b) =>
        a.value < b.value ? 1 : a.value > b.value ? -1 : 0
      )
    },
    handleCheckAllChange(val) {
      this.$set(this.form, 'group', val ? this.group.map(item => item.key) : [])
      this.isIndeterminate = false
    },
    handleCheckedChange(value) {
      const checkedCount = value.length
      this.checkAll = checkedCount === this.group.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.group.length
    },
    onDataType() {
      this.selectYear = undefined
      this.tidal()
    },
    onSelectYear() {
      this.tidal()
    },
    getTodayTime(date) {
      const day2 = date ? new Date(date) : new Date()
      day2.setTime(day2.getTime())
      return (
        day2.getFullYear() +
        '-' +
        (day2.getMonth() < 9
          ? '0' + (day2.getMonth() + 1)
          : day2.getMonth() + 1) +
        '-' +
        (day2.getDate() < 10 ? '0' + day2.getDate() : day2.getDate()) +
        '-' +
        day2.getHours() +
        '-' +
        day2.getMinutes()
      )
    },
    getSiteParams(data) {
      const vm = this
      const t = data ? vm.getTodayTime(data) : vm.getTodayTime()
      const format = t.split('-')
      return format
    },
    tidal(data, id, chartName = 'chart') {
      const vm = this
      const format = vm.selectYear
        ? vm.getSiteParams(vm.selectYear)
        : vm.getSiteParams()
      const params = {
        selfAreaId: this.selfAreaId,
        siteId: this.siteId,
        year: format[0],
        dataType: this.dataType
      }
      if (this.dataType === '日') {
        params.month = format[1]
        params.day = format[2]
      } else if (this.dataType === '月') {
        params.month = format[1]
      }
      // 浮层数据获取参数
      if (data && data.time) {
        if (this.dataType === '月') {
          params.year = this.selectYear
            ? this.selectYear
            : new Date().getFullYear()
          params.month = this.monthCache
            ? this.monthCache
            : new Date().getMonth() < 9
              ? '0' + (new Date().getMonth() + 1)
              : new Date().getMonth() + 1
          params.day = Number(data.time) < 10 ? '0' + data.time : data.time
        } else if (this.dataType === '年') {
          params.year = this.selectYear
            ? this.selectYear
            : new Date().getFullYear()
          params.month = Number(data.time) < 10 ? '0' + data.time : data.time
        }
      }
      Api.siteStatistics(params)
        .then((res) => {
          if (res.code === 200) {
            // 使用 reduce 方法计算属性 num 的总和
            // 总租车数
            this.totalRentNum = res.data.reduce((num, obj) => num + obj.rent_num, 0)
            // 总还车数
            this.totalReturnNum = res.data.reduce((num, obj) => num + obj.return_num, 0)
            // 总上架数
            this.totalUpNum = res.data.reduce((num, obj) => num + obj.up_num, 0)
            // 总下架数
            this.totalDownNum = res.data.reduce((num, obj) => num + obj.down_num, 0)
            vm.$nextTick(() => {
              let type = '年'
              const today = new Date()
              let slicelength = 0
              if (params.year) {
                type = '年'
                if (!params.month && params.year == today.getFullYear()) {
                  slicelength = today.getMonth() + 1
                }
              }
              if (params.month) {
                type = '月'
                if (!params.day && params.month == today.getMonth() + 1) {
                  slicelength = today.getDate()
                }
              }
              if (params.day) {
                type = '日'
                if (params.day == today.getDate()) {
                  slicelength = today.getHours() + 1
                }
              }
              if (slicelength) {
                res.data = res.data.slice(0, slicelength)
                console.log(res.data, 111)
                if (res.data.slice(-1)[0].num == 0) {
                  res.data.splice(-1)
                }
              }
              this.initScale(
                this.translateLineData(res.data, type),
                id,
                chartName
              )
            })
          } else {
            vm.$message.warning(res.message)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },

    translateLineData(data, datatype) {
      const arr = []
      data.forEach((val) => {
        let time = ''
        let date = ''
        if (datatype === '年') {
          time = Number(val.date.split('-')[1]) + '月'
          date = Number(val.date.split('-')[1])
        } else if (datatype === '月') {
          const day = Number(val.date.split('-')[2])
          time = Number(day) < 10 ? '0' + day : String(day)
          date = day
        } else if (datatype === '日') {
          time = val.hour + '点'
          date = val.hour
        }
        arr.push(
          {
            date: time,
            numkey: '站点驶入率',
            value: val.return_num_per,
            time: date
          }, {
            date: time,
            numkey: '站点驶出率',
            value: val.rent_num_per,
            time: date
          }, {
            date: time,
            numkey: '还车数',
            value: val.return_num,
            time: date
          }, {
            date: time,
            numkey: '租车数',
            value: val.rent_num,
            time: date
          }, {
            date: time,
            numkey: '上架数',
            value: val.up_num,
            time: date
          },
          {
            date: time,
            numkey: '下架数',
            value: val.down_num,
            time: date
          }
        )
      })
      return arr
    },
    initScale(data, id, chartName) {
      // 有id表示自定义
      if (data.legnth == 0) {
        return
      }
      if (this[chartName]) {
        this[chartName].destroy()
      }
      let h = 70
      if (this.dataType === '年') {
        h = 110
      }
      this.height = this.realHeight - h
      console.log(data)
      this[chartName] = new Line(id || 'chart1', {
        data: data,
        height: this.realHeight - h,
        yField: 'value',
        xField: 'date',
        seriesField: 'numkey',
        legend: {
          position: 'top-left',
          flipPage: false,
          itemName: {
            style: {
              fill: '#999'
            }
          }
        },
        point: {
          shape: () => {
            return 'circle'
          },
          size: 3
        }
      })
      this[chartName].on('element:click', (event) => {
        console.log(event, 11)
        // 点击数据
        if (event && event.data && event.data.data && event.data.data.value) {
          this.onClickPoint(event.data.data)
        }
      })
      this[chartName].render()
    },
    onClickPoint(data) {
      const vm = this
      if (this.dataType === '日') {
      } else if (this.dataType === '月') {
        vm.dialogTitleDay =
          new Date().getFullYear() +
          '-' +
          (new Date().getMonth() + 1) +
          '-' +
          data.date +
          (vm.dark ? '曲线图' : ' 品牌投放量曲线')
        vm.$refs.daychart.onShowDialog()
        vm.$nextTick(() => {
          vm.tidal(data, 'chart3', 'chartDays')
        })
      } else if (this.dataType === '年') {
        vm.monthCache = Number(data.date) < 10 ? '0' + data.date : data.date
        if (vm.selectYear) {
          vm.dialogTitleMonth =
            vm.selectYear +
            '-' +
            data.date +
            (vm.dark ? '曲线图' : ' 品牌投放量曲线')
        } else {
          vm.dialogTitleMonth =
            new Date().getFullYear() +
            '-' +
            data.date +
            (vm.dark ? '曲线图' : ' 品牌投放量曲线')
        }
        vm.$refs.monthchart.onShowDialog()
        vm.$nextTick(() => {
          vm.tidal(data, 'chart2', 'chartMonths')
        })
      }
    },
    handleCloseMonth() {
      this.monthCache = null
      this.$refs.monthchart.onCloseDialog()
    },
    handleCloseDay() {
      this.$refs.daychart.onCloseDialog()
    },
    onExportLogShowModel() {
      this.$refs['export-log'].onShowDialog()
    },
    handleCloseExportLog() {
      this.form = {
        dataType: '日',
        exportTime: new Date(),
        group: []
      }
      this.$refs['export-log'].onCloseDialog()
    },
    onExportLog() {
      const vm = this
      const time = this.dayjs(this.form.exportTime)
      const dataType = this.form.dataType
      const params = {
        siteId: this.siteId,
        selfAreaId: this.selfAreaId,
        group: this.form.group.sort((a, b) => { return a - b }).join(','),
        year: time.format('YYYY'),
        dataType: dataType
      }
      if (dataType === '日') {
        params.month = time.format('MM')
        params.day = time.format('DD')
      } else if (dataType === '月') {
        params.month = this.dayjs(this.form.exportTime).format('MM')
      }
      const loading = vm.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      Api.siteStatisticsOutput(params).then((res) => {
        loading.close()
        vm.$message({
          type: 'success',
          message: '数据导出成功！'
        })
        vm.handleCloseExportLog()
        const content = res
        const blob = new Blob([content])
        const fileName = '站点使用率统计.xls'
        if ('download' in document.createElement('a')) {
          // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.title {
  display: inline-block;
}
.btn-group {
  float: right;
  .btn-hover:hover {
    border-color: #48efef; /* 鼠标悬浮时改变边框颜色 */
  }
}
</style>
